import React from 'react';
import YearTransitionBanner from './YearTransitionBanner';

interface YearTransitionOverlayProps {
  nextYear: number;
  stability: number;
  correctCount: number;
  total: number;
  onContinue: () => void;
}

const YearTransitionOverlay: React.FC<YearTransitionOverlayProps> = ({
  nextYear,
  onContinue,
}) => {
  return (
    <div className="absolute inset-0 z-30 flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <div className="w-full flex flex-col items-center gap-8">
        <YearTransitionBanner nextYear={nextYear} />

        <button
          onClick={onContinue}
          className="px-8 py-2.5 rounded-full bg-teal-500 hover:bg-teal-600 transition font-semibold text-sm text-white font-caudex shadow-lg"
        >
          Continue Trial
        </button>
      </div>
    </div>
  );
};

export default YearTransitionOverlay;